
import Icon from "@mdi/react";
import { mdiArrowRightThin, mdiEmail, mdiFacebook, mdiPhone } from "@mdi/js";

import { useUser } from "../User";
import Sponsors from "./Sponsors";
import { Link, useLang } from "./Language";

export default function Footer() {
    const lang = useLang();
    const { user, setUser } = useUser();

    return <>
        <div className="content footer-start">
            <Sponsors />
        </div>
        <footer>
            <div className="content">
                <div className="columns">
                    <div>
                        <h5>{lang === "cs" ? "Kontakty" : "Kontakty"}</h5>
                        {/* lang === "cs" ? "Adresa sídla" : "Adres siedziby" */}
                        <p>
                            Roztocká 500 <br />
                            514 01 Jilemnice
                        </p>
                        <p>
                            <a href="mailto:jilemnicko@jilemnicko-so.cz"><Icon path={mdiEmail} size={1} /> jilemnicko@jilemnicko-so.cz</a>
                            <a href="tel:+420737529723"><Icon path={mdiPhone} size={1} /> +420 737 529 723</a>
                            <a target="_blank" href="https://www.facebook.com/jilemnicko/"><Icon path={mdiFacebook} size={1} /> facebook</a>
                        </p>
                    </div>
                    <div>
                        <h5>{lang === "cs" ? "Odkazy" : "Linki"}</h5>
                        <Link to="/">{lang === "cs" ? "Úvod" : "Wstęp"}</Link>
                        <Link to="/o-nas">{lang === "cs" ? "O nás" : "O nas"}</Link>
                        <Link to="/uredni-deska">{lang === "cs" ? "Úřední deska" : "Tablica urzędowa"}</Link>
                        <Link to="/verejne-dokumenty">{lang === "cs" ? "Veřejné dokumenty" : "Dokumenty publiczne"}</Link>
                        <Link to="/turista">{lang === "cs" ? "Turista" : "Turysta"}</Link>
                        <Link to="/vzdelavani">{lang === "cs" ? "Vzdělávání" : "Edukacja"}</Link>
                        <Link to="/krakonosovy-letni-podvecery">{lang === "cs" ? "Krakonošovy letní podvečery" : "Letnie wieczory z karkonoskim duchem"}</Link>
                        <Link to="/kontakty">{lang === "cs" ? "Kontakty" : "Kontakty"}</Link>
                    </div>
                    <div>
                        {!user && <>
                            <h5>{lang === "cs" ? " Starosta" : "Burmistrz"}</h5>
                            <Link to="/starosta">→ {lang === "cs" ? " Přihlášení" : "Logowanie"}</Link>
                            <h5 style={{ paddingTop: "16px" }}>{lang === "cs" ? " Administrace" : "Administracja"}</h5>
                            <Link to="/starosta">→ {lang === "cs" ? " Přihlášení" : "Logowanie"}</Link>
                        </>}
                        {user && <>
                            <h5>{user.name}</h5>
                            <Link to="/starosta">
                                <Icon
                                    path={mdiArrowRightThin}
                                    size={1}
                                />{" "}
                                {user.roles.includes("admin") ? "Administrace" : "Starosta"}
                            </Link>
                            <a onClick={() => setUser(null)}>
                                <Icon
                                    path={mdiArrowRightThin}
                                    size={1}
                                />{" "}
                                Odhlásit se
                            </a>
                        </>}
                    </div>
                </div>
            </div>
            <div className="copyright">
                © Copyright 2025 <Link to="/">Jilemnicko - společenství obcí</Link>
                <span className="left">
                    {lang === "cs" ? "Design" : "Projekt graficzny"}: <a href="https://www.graphto.art/" target="__blank"><b>graph</b>to</a>
                </span>
                <span className="right">
                    {lang === "cs" ? "Vytvořil" : "Vyrobil"}: <a href="https://paulu.cz/" target="__blank"><b>Filip</b></a>
                </span>
            </div>
        </footer>
    </>;
}